export const chainOfferData = {
  data() {
    return {
      bgFailed: false,
    };
  },
  computed: {
    offer() {
      return this.offerData;
    },
    // Offer nested under the chain wrapper's `.offer`; fall back to the wrapper.
    chainOffer() {
      return this.offerData?.offer || this.offerData || null;
    },
    // Title is a baked logo image from the chain config (no text/color styling).
    chainLogo() {
      return this.chainOffer?.chain?.logo_image_path_full || "";
    },
    displayConfig() {
      const raw = this.chainOffer && this.chainOffer.display_config;
      if (!raw) return null;
      try {
        return typeof raw === "string" ? JSON.parse(raw) : raw;
      } catch (e) {
        console.error("Error parsing chain display_config:", e);
        return null;
      }
    },
    // Optional countdown color from ACP display_config.style["timer-color"];
    // drives both the hourglass icon and the countdown text via a CSS var.
    timerStyle() {
      const color = this.displayConfig?.style?.["timer-color"];
      return color ? { "--timer-color": color } : {};
    },
    // Countdown target (ms). Prefer absolute end_at; fall back to a value
    // derived from seconds_remaining.
    endDate() {
      const endAt = this.offerData && this.offerData.end_at;
      if (endAt) return new Date(endAt).getTime();
      const secs = this.offerData && this.offerData.seconds_remaining;
      return secs ? Date.now() + secs * 1000 : 0;
    },
    offerBackgroundStyle() {
      const url = this.chainOffer && this.chainOffer.image_path_full;
      const fallback = "linear-gradient(#444, #444)";

      const style = {
        backgroundImage: !url || this.bgFailed ? fallback : `url("${url}")`,
      };
      // Optional frame color from ACP display_config.style["border-color"].
      const borderColor = this.displayConfig?.style?.["border-color"];
      if (borderColor) style["--chain-border-color"] = borderColor;
      return style;
    },
  },
  methods: {
    onBgLoad() {
      this.bgFailed = false;
      this.loading = false;
    },
    onBgError() {
      this.bgFailed = true;
      this.loading = false;
    },
  },
};
